module.exports = __webpack_public_path__ + "img/23.6.CODm.f802c235.png";